import DatePicker from "react-date-picker";
import Select from "react-select";
import styled from "styled-components";
import Button from "../../../bootstrap/Button";
import TextField from "../../../bootstrap/TextField";

export const Form = styled.form`
  padding: 0;
  margin: 0;
  width: 100%;
`;

export const InnerForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  background: white;
  padding: 28px 32px;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(0, 0, 0, 0.03);
  position: relative;
  
  @media (max-width: 1024px) {
    padding: 20px;
  }
`;

export const InputsRow = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  align-items: center;
  
  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const Location = styled.div`
  display: flex;
  flex: 1.2;
  gap: 12px;
  position: relative;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const DateContainer = styled.div`
  display: flex;
  flex: 1.2;
  gap: 12px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background: #fcfdfe;
  border: 1.5px solid #eef2f5;
  border-radius: 8px;
  padding: 10px 18px;
  min-height: 74px;
  justify-content: center;
  transition: all 0.3s ease;
  position: relative;
  
  &:hover {
    border-color: #dbe3eb;
    background: #fafbfc;
  }
  
  &:focus-within {
    border-color: ${props => props.focusColor || '#1FBA30'};
    background: white;
    box-shadow: 0 0 0 4px ${props => props.focusColor ? props.focusColor + '15' : '#1FBA3015'};
  }
`;

export const InputLabel = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: #8fa0b0;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const Calendar = styled(DatePicker)`
  display: block;
  width: 100%;
  
  .react-date-picker__wrapper {
    border: none !important;
  }
  
  .react-date-picker__inputGroup {
    font-size: 15px;
    font-weight: 600;
    color: #1a2b3c;
  }
  
  .react-date-picker__inputGroup__input {
    color: #1a2b3c !important;
    font-weight: 600;
    outline: none;
  }
  
  .react-date-picker__inputGroup__divider {
    font-size: 0;
  }
  
  .react-date-picker__inputGroup__divider:before {
    content: "-";
    font-size: 14px;
    color: #a0aec0;
    margin: 0 4px;
  }
  
  .react-date-picker__button {
    padding: 0px 4px;
    svg {
      stroke: #718096 !important;
      width: 16px;
      height: 16px;
    }
  }
`;

export const SearchLocation = styled(Select)`
  font-size: 15px;
  font-weight: 600;
  text-transform: capitalize;
  width: 100%;
  
  > div {
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    padding: 0 !important;
    min-height: auto !important;
    cursor: pointer;
  }
  
  // Value container
  .css-3w2yfm-ValueContainer,
  .css-1d8n9bt {
    padding: 0 !important;
  }
  
  // Dropdown indicators
  .css-1wy0on6 {
    display: none !important;
  }
  
  input {
    padding: 0 !important;
    font-weight: 600;
    color: #1a2b3c !important;
  }
  
  .css-1dimb5e-singleValue {
    color: #1a2b3c !important;
    margin: 0 !important;
  }
  
  .css-1wa3jt0-placeholder {
    color: #a0aec0 !important;
    margin: 0 !important;
  }
`;

export const SearchBtnArea = styled.div`
  display: flex;
  align-items: center;
  
  @media (max-width: 1024px) {
    justify-content: stretch;
    width: 100%;
    margin-top: 8px;
  }
`;

export const SearchBtn = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 8px;
  width: 74px;
  height: 74px;
  cursor: pointer;
  background: ${props => props.searchbtnbgcolor || '#1FBA30'};
  color: ${props => props.btntextcolor || 'white'};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 12px ${props => props.searchbtnbgcolor ? props.searchbtnbgcolor + '40' : '#1FBA3040'};
  
  &:hover {
    background: ${props => props.searchbtnbghvcolor || '#1aa329'};
    transform: translateY(-2px);
    box-shadow: 0 6px 20px ${props => props.searchbtnbgcolor ? props.searchbtnbgcolor + '50' : '#1FBA3050'};
  }
  
  &:active {
    transform: translateY(0);
  }
  
  svg {
    width: 28px;
    height: 28px;
    fill: currentColor;
  }

  @media (max-width: 1024px) {
    width: 100%;
    height: 54px;
    border-radius: 8px;
    gap: 8px;
    span {
      display: inline !important;
      font-weight: 600;
      font-size: 15px;
    }
  }
`;

export const ExchangeButton = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 36px;
  height: 36px;
  background: white;
  border: 1.5px solid #eef2f5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0,0,0,0.05);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover {
    border-color: ${props => props.color || '#1FBA30'};
    transform: translate(-50%, -50%) rotate(180deg);
    box-shadow: 0 6px 12px rgba(0,0,0,0.08);
  }
  
  svg {
    width: 18px;
    height: 18px;
    fill: ${props => props.color || '#1FBA30'};
  }
  
  @media (max-width: 768px) {
    left: auto;
    right: 24px;
    top: 50%;
    transform: translateY(-50%);
    &:hover {
      transform: translateY(-50%) rotate(180deg);
    }
  }
`;

// Tabs layout
export const TabContainer = styled.div`
  display: flex;
  background: white;
  padding: 4px;
  border-radius: 30px;
  margin: 0 auto -20px auto;
  width: 90%;
  max-width: 420px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  border: 1px solid #eef2f6;
  z-index: 10;
  position: relative;

  @media (max-width: 768px) {
    width: 95%;
    margin: 0 auto -16px auto;
  }
`;

export const TabItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 13.5px;
  font-weight: 700;
  color: ${props => props.active ? (props.activeColor || '#1FBA30') : '#64748b'};
  background: ${props => props.active ? '#f1f5f9' : 'transparent'};
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.25s ease;
  flex: 1;
  
  svg {
    width: 16px;
    height: 16px;
    fill: currentColor;
  }
  
  &:hover {
    color: ${props => props.activeColor || '#1FBA30'};
    background: ${props => props.active ? '#f1f5f9' : '#f8fafc'};
  }

  @media (max-width: 768px) {
    font-size: 12px;
    gap: 4px;
    padding: 6px 8px;
    
    svg {
      width: 14px;
      height: 14px;
    }
  }

  @media (max-width: 360px) {
    font-size: 11px;
    gap: 2px;
    padding: 5px 6px;
  }
`;

export const TrendingWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 12px;
  font-size: 13px;
  color: #64748b;
  padding: 12px 0 0 0;
  width: 100%;
  border-top: 1px solid #f1f5f9;
  
  .title {
    font-weight: 700;
    color: #475569;
  }
  
  .route {
    background: #f1f5f9;
    padding: 4px 12px;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-weight: 600;
    color: #475569;
    border: 1px solid #e2e8f0;
    
    &:hover {
      background: ${props => props.color || '#1FBA30'};
      color: white;
      border-color: ${props => props.color || '#1FBA30'};
      transform: translateY(-1px);
    }
  }
`;

// Start booking page (sticky compact search form)
export const BookingPageInnerForm = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  align-items: center;
  background: white;
  padding: 16px 20px;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  border: 1px solid #eef2f5;
  
  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const BookingPageLocation = styled.div`
  display: flex;
  flex: 2;
  gap: 12px;
  position: relative;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const BookingPageDate = styled.div`
  display: flex;
  flex: 2;
  gap: 12px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const BookingPageSearchBtn = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 6px;
  width: 54px;
  height: 54px;
  cursor: pointer;
  background: ${props => props.searchbtnbgcolor || '#1FBA30'};
  color: ${props => props.btntextcolor || 'white'};
  transition: all 0.25s ease;
  box-shadow: 0 3px 8px ${props => props.searchbtnbgcolor ? props.searchbtnbgcolor + '30' : '#1FBA3030'};
  
  &:hover {
    background: ${props => props.searchbtnbghvcolor || '#1aa329'};
    transform: translateY(-1px);
  }
  
  svg {
    width: 22px;
    height: 22px;
    fill: currentColor;
  }

  @media (max-width: 1024px) {
    width: 100%;
    height: 48px;
  }
`;
